module.exports = __webpack_public_path__ + "static/img/icon8.f4130b17.png";